import { useTranslation } from "react-i18next";

export type MCPBadgeStatus = "needsAttention" | "disabled" | "online" | "offline" | "testing";

const BADGE_CLASSES: Record<MCPBadgeStatus, string> = {
  needsAttention: "bg-amber-100 text-amber-950 dark:bg-amber-900/70 dark:text-white",
  disabled: "bg-blue-100 text-blue-950 dark:bg-blue-900/70 dark:text-white",
  online: "bg-emerald-100 text-emerald-950 dark:bg-emerald-900/70 dark:text-white",
  offline: "bg-rose-100 text-rose-950 dark:bg-rose-900/70 dark:text-white",
  testing: "bg-muted text-muted-foreground",
};

export default function MCPStatusBadge({ status, title }: { status: MCPBadgeStatus; title?: string }) {
  const { t } = useTranslation();
  return (
    <span title={title} className={`shrink-0 rounded-[12px] px-2 py-1 text-xs font-medium ${BADGE_CLASSES[status]}`}>
      {t(`mcpPage.status.${status}`)}
    </span>
  );
}
